import axios, { AxiosResponse } from "axios";
import Config from "../config/constants";

// 모든 구매내역 가져오기
export const apiGetAllPurchases = async (params = {}): Promise<AxiosResponse> => {
  try {
    console.log("API_HOST 값:", Config.API_HOST);
    // 백엔드 코드를 참고하여 실제 URL을 구성합니다
    // getAllPurchases 메서드가 노출된 엔드포인트로 수정해야 합니다
    const url = `${Config.API_HOST}/api/gifts/admin/purchases`;
    console.log("API URL:", url);
    
    // 백엔드가 요구하는 형식으로 파라미터 구성
    // 백엔드는 page와 limit만 필요로 함
    // API 호출 전 로그
    console.log("Sending request with params:", params);
    
    const res = await axios.get(url, {
      params: params,
      // 타임아웃 설정
      timeout: 10000,
      // 인증 헤더 추가
      headers: {
        'Content-Type': 'application/json',
      }
    });
    
    console.log("API Response:", res.data);
    return res;
    
  } catch (error) {
    // 에러 처리
    console.error("API Error:", error);
    if (axios.isAxiosError(error)) {
      console.error("Response data:", error.response?.data);
      console.error("Status code:", error.response?.status);
    }
    throw error;
  }
}

// 특정 사용자의 구매내역 가져오기
export const apiGetUserPurchases = async (userId: number): Promise<AxiosResponse> => {
  try {
    console.log("API_HOST 값:", Config.API_HOST);
    const url = `${Config.API_HOST}/api/gifts/user/purchases`;
    console.log("API URL:", url);
    
    const params = {
      userId: userId
    };
    
    // API 호출 전 로그
    console.log("Sending request with params:", params);
    
    const res = await axios.get(url, {
      params: params,
      // 타임아웃 설정
      timeout: 10000,
      // 인증 헤더 추가
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
    
    console.log("API Response:", res.data);
    return res;
    
  } catch (error) {
    // 에러 처리
    console.error("API Error:", error);
    if (axios.isAxiosError(error)) {
      console.error("Response data:", error.response?.data);
      console.error("Status code:", error.response?.status);
    }
    throw error;
  }
}

// 기프티콘 구매하기
export const apiPurchaseGift = async (giftId: number, quantity: number = 1): Promise<AxiosResponse> => {
  try {
    console.log("API_HOST 값:", Config.API_HOST);
    const url = `${Config.API_HOST}/api/gifts/purchase`;
    console.log("API URL:", url);
    
    const data = {
      giftId,
      quantity
    };
    
    // API 호출 전 로그
    console.log("Sending request with data:", data);
    
    const res = await axios.post(url, data, {
      // 타임아웃 설정
      timeout: 10000,
      // 인증 헤더 추가
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
    
    console.log("API Response:", res.data);
    return res;
    
  } catch (error) {
    // 에러 처리
    console.error("API Error:", error);
    if (axios.isAxiosError(error)) {
      console.error("Response data:", error.response?.data);
      console.error("Status code:", error.response?.status);
    }
    throw error;
  }
}

// 기프티콘 사용하기
export const apiUseGift = async (purchaseId: number): Promise<AxiosResponse> => {
  try {
    console.log("API_HOST 값:", Config.API_HOST);
    const url = `${Config.API_HOST}/api/gifts/use/${purchaseId}`;
    console.log("API URL:", url);
    
    const res = await axios.post(url, {}, {
      // 타임아웃 설정
      timeout: 10000,
      // 인증 헤더 추가
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
    
    console.log("API Response:", res.data);
    return res;
    
  } catch (error) {
    // 에러 처리
    console.error("API Error:", error);
    if (axios.isAxiosError(error)) {
      console.error("Response data:", error.response?.data);
      console.error("Status code:", error.response?.status);
    }
    throw error;
  }
}